import { NewsDTO } from '../news/news.dto';
import { TradeRequestDTO } from '../trade-request/trade-request.dto';

export class DashboardDTO {

    messages: Array<any>;

    notifications: Array<any>;

    events: Array<any>;

    tradeRequests: Array<TradeRequestDTO>;

    news: Array<NewsDTO>;

}
